<template>
  <div
    class="related-searches-drawer"
    :class="stateClass"
  >
    <div
      class="related-searches-header"
      @click.prevent="toggle"
    >
      <h3
        class="related-searches-title"
        v-html="title"
      />
      <div class="toggle">
        <i class="icon-toggle" />
      </div>
    </div>

    <div
      class="related-searches-content"
    >
      <QuickViewSearchButton
        v-for="search in searches"
        :key="search"
        :search="search"
        @search="doSearch"
      />
    </div>
  </div>
</template>

<script>
import QuickViewSearchButton from './QuickViewSearchButton.vue';
import { QUICK_HITS_RELATED_SEARCHES } from '../constants';

export default {
  name: 'RelatedSearchesDrawer',
  components: { QuickViewSearchButton },
  props: {
    quickHitTitle: String,
    title: {
      type: String,
      default: 'Related Searches',
    },
  },
  data() {
    return {
      isOpen: false,
      searches: QUICK_HITS_RELATED_SEARCHES[this.quickHitTitle] || [],
    };
  },
  computed: {
    stateClass() {
      return {
        open: this.isOpen,
      };
    },
  },
  mounted() {
    this.$native.send({
      event: 'related-searches:drawer-enable',
      bounds: this.bounds(),
    });
  },
  beforeDestroy() {
    this.close();
    this.$native.send({
      event: 'related-searches:drawer-disable',
    });
  },
  methods: {
    bounds() {
      const box = document.querySelector('.related-searches-drawer').getBoundingClientRect();
      return `{{${box.x},${box.y}}, {${box.right},${box.bottom}}}`;
    },

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },

    open() {
      this.$native.send({ event: 'related-searches:active' });
      this.isOpen = true;
    },

    close() {
      this.$native.send({ event: 'related-searches:inactive' });
      this.isOpen = false;
    },

    doSearch(s) {
      this.$native.send({ event: 'related-searches:value-selected', value: s });
    },
  },
};
</script>

<style lang="scss">
.related-searches-drawer {
  position: fixed;
  bottom: 0;
  right: 3px;
  left: 3px;
  transform: translate(0, calc(100% - 60px));
  display: flex;
  flex-direction: column;
  background-color: $surface-light;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  z-index: 100;
  transition: all 0.75s cubic-bezier(0.19, 1, 0.22, 1);
  color: $text-tertiary;

  &.open {
    height: auto;
    transform: translate(0, 0);
  }
}

.related-searches-header {
  position: relative;
  height: 60px;
  line-height: 60px;
  padding: 0 1.25rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  background: $related-searches-drawer;
  border-radius: 1rem 1rem 0 0;

  .toggle {
    position: absolute;
    top: 50%;
    right: 1.5rem;
    transform: translate(0, -50%);
  }

  .icon-toggle {
    display: inline-block;
    padding: 4px;
    transform: translate(0, 2px) rotate(-135deg);
    border: solid white;
    border-width: 0 2px 2px 0;
    transition: transform 0.5s;
  }

  .open & .icon-toggle {
    transform: translate(0, -2px) rotate(45deg);
  }
}

.related-searches-title {
  margin: 0;
  font-size: 1rem;
}

.related-searches-content {
  background: $ribbon-header;
  flex: 1;
  height: 100%;
  color: black;
}
</style>
